<script>
/**
 * @overview 课时管理 - 入口
 *
 * @author  huojinzhao
 */

export default {
  name: "ViewCourse",
};
</script>

<template>
  <div class="layout-screen view-course">

    <TheHeader />

    <router-view />
  </div>
</template>

<style lang="postcss">
.view-course {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
